import * as React from 'react';
import { MediaQuery, Carousel } from '@grandvisionhq/common';
import { Container } from '@grandvisionhq/elements';

const CategoryLinks = ({ children  })=>{
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    if (!children || !Array.isArray(children)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("article", {
        className: "category-links"
    }, /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement("div", {
        className: "category-links__content"
    }, isSmallScreen ? /*#__PURE__*/ React.createElement(Carousel, {
        pagination: true
    }, children) : children)));
};

export { CategoryLinks as default };
//# sourceMappingURL=CategoryLinks.js.map
